var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSalaryIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4737 4.93962V8.80214C14.4737 11.1121 13.1538 12.1021 11.1738 12.1021H4.58125C4.24375 12.1021 3.92125 12.0722 3.62125 12.0047C3.43375 11.9747 3.25375 11.9222 3.08875 11.8622C1.96375 11.4422 1.28125 10.4671 1.28125 8.80214V4.93962C1.28125 2.62962 2.60125 1.63965 4.58125 1.63965H11.1738C12.8538 1.63965 14.0613 2.35214 14.3838 3.97964C14.4363 4.27964 14.4737 4.58712 14.4737 4.93962Z",
    stroke: "#544D5E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7236 7.18947V11.052C16.7236 13.362 15.4036 14.352 13.4236 14.352H6.83109C6.27609 14.352 5.7736 14.277 5.3386 14.112C4.4461 13.782 3.83859 13.0995 3.62109 12.0045C3.92109 12.072 4.24359 12.102 4.58109 12.102H11.1736C13.1536 12.102 14.4736 11.112 14.4736 8.80199V4.93947C14.4736 4.58697 14.4436 4.27199 14.3836 3.97949C15.8086 4.27949 16.7236 5.28447 16.7236 7.18947Z",
    stroke: "#544D5E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87064 8.85455C8.96416 8.85455 9.85065 7.96807 9.85065 6.87454C9.85065 5.78102 8.96416 4.89453 7.87064 4.89453C6.77711 4.89453 5.89062 5.78102 5.89062 6.87454C5.89062 7.96807 6.77711 8.85455 7.87064 8.85455Z",
    stroke: "#544D5E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58203 5.22461V8.52463",
    stroke: "#544D5E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1641 5.22461V8.52463",
    stroke: "#544D5E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryIcon2);
export default __webpack_public_path__ + "static/media/salary_icon2.dcb78a26d105085dc1594a5da5335c7c.svg";
export { ForwardRef as ReactComponent };